var map = {
	"./Attachment.svg": "4825",
	"./Icd.svg": "62dd",
	"./Icons_Buttons.svg": "24b7",
	"./Item.svg": "2e65c",
	"./Note.svg": "c352",
	"./ViewMenu.svg": "2b77",
	"./add.svg": "f0df",
	"./admission-icon.svg": "6c96",
	"./approve.svg": "22c0",
	"./approved.svg": "3c4e",
	"./attachment-icon.svg": "028e",
	"./cancel-claim.svg": "e6db",
	"./cancel.svg": "5e8a",
	"./cancelDisabled.svg": "390c",
	"./cancelMenu.svg": "b956",
	"./canceled.svg": "8f21",
	"./chief-icon.svg": "f492",
	"./d-arrow.svg": "dd55",
	"./downloadIcon.svg": "aac7",
	"./error-list.svg": "d476",
	"./error.svg": "bba8",
	"./errorIcon.svg": "67e9",
	"./errorList.svg": "6d85",
	"./errorModal.svg": "9798",
	"./errorResponse.svg": "f995",
	"./hold.svg": "ee4e",
	"./iCD10-icon.svg": "b774",
	"./ic_capture_patient.svg": "90b4",
	"./info-icon.svg": "c0a5",
	"./invalid.svg": "bc74",
	"./left-ar.svg": "f55f",
	"./new.svg": "db19",
	"./no-data-found.svg": "c390",
	"./note-icon.svg": "c14f",
	"./partiallyApproved.svg": "1041",
	"./patient-icon.svg": "f2ed",
	"./payNotice.svg": "e17c",
	"./paymentReconciled.svg": "6c74",
	"./queued.svg": "fa39",
	"./queuedHIC.svg": "5f91",
	"./queuedNphies.svg": "021f",
	"./reject.svg": "f38d",
	"./rejected.svg": "adfd",
	"./send.svg": "0c69",
	"./sendClaim.svg": "9dfa",
	"./sendToNphies.svg": "a15a",
	"./sendToNphiesDisabled.svg": "23d8",
	"./sendToNphiesMenu.svg": "448a",
	"./sendnphies-icon.svg": "73e9",
	"./undo-approve.svg": "79ad",
	"./validated.svg": "e2ff",
	"./viewImg.svg": "590c",
	"./visit-icon.svg": "005d",
	"./warning-arr.svg": "305b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ded0";